<template>
  <div>
    <table class="table table-bordered">
      <tr>
        <td width="200px">학습유형</td>
        <td>{{ s_type_text }}</td>
      </tr>
      <tr>
        <td width="200px">유형</td>
        <td>{{ grp_type_text }}</td>
      </tr>
      <tr>
        <td width="200px">문제유형</td>
        <td>{{ q_type_text }}</td>
      </tr>

      <tr>
        <td width="200px">지시문</td>
        <td>{{ meta.statement }}</td>
      </tr>

      <template v-if="grp_type == '2'">
        <tr>
          <td width="200px">지문</td>
          <td>{{ meta.jimun }}</td>
        </tr>

        <tr>
          <td width="200px">해석</td>
          <td>{{ meta.translate }}</td>
        </tr>
        <tr>
          <td width="200px">해설</td>
          <td>{{ meta.qcomment }}</td>
        </tr>
      </template>
      <template v-if="grp_type == 1">
        <tr>
          <td width="200px">문제</td>
          <td>{{ form.title }}</td>
        </tr>

        <tr>
          <td width="200px">정답1</td>
          <td>다음의 문장을 지식..</td>
        </tr>
        <tr>
          <td width="200px">정답2</td>
          <td>다음의 문장을 지식..</td>
        </tr>
        <tr>
          <td width="200px">출제포인트</td>
          <td>{{ form.intent1 }}</td>
        </tr>

        <tr>
          <td width="200px">해석</td>
          <td v-html="meta.translate"></td>
        </tr>
        <tr>
          <td width="200px">해설</td>
          <td v-html="meta.qcomment"></td>
        </tr>

        <tr>
          <td width="200px">이미지</td>
          <td>
            <img :src="form.image" />
          </td>
        </tr>
        <tr>
          <td width="200px">동영상1</td>
          <td>..</td>
        </tr>
        <tr>
          <td width="200px">음원</td>
          <td>
            {{ form.sound }}
          </td>
        </tr>
        <tr>
          <td width="200px">난이도</td>
          <td>
            {{ form.level }}
          </td>
        </tr>

        <tr v-show="1 == 2">
          <td width="200px">어휘</td>
          <td>{{ form.word_level }}</td>
        </tr>
        <tr>
          <td width="200px">기출정보</td>
          <td>{{ form.prevtest_info }}</td>
        </tr>
      </template>
      <template v-else>
        <tr>
          <td width="200px">그룹관련</td>
          <td>{{ form.prevtest_info }}</td>
        </tr>
      </template>
    </table>
    <b-button variant="primary">수정하기</b-button>
  </div>
</template>

<script>
import PreviewQType1 from "@/components/preview/PreviewQType1";
export default {
  components: [PreviewQType1],
  mounted() {
    this.$store.commit("updateDebug", this.$store.state.questionmeta.grp_type);
  },
  computed: {
    s_type_text() {
      let s_type = this.$store.state.questionmeta.std_type;
      return s_type;
    },
    grp_type() {
      return this.$store.state.questionmeta.grp_type;
    },
    grp_type_text() {
      let g = this.$store.state.questionmeta.grp_type;
      return g;
    },
    q_type_text() {
      let q = this.$store.state.questionform.q_type;
      return q;
    },
    meta() {
      return this.$store.state.questionmeta;
    },
    form() {
      return this.$store.state.questionform;
    },
  },
};
</script>


<style lang="scss" scoped>
</style>